import React from "react";
import { useI18n } from "@/i18n/I18nContext";

function LegalLayout({ titleKey, updatedKey, introKey, sections }) {
  const { t } = useI18n();
  return (
    <main className="py-20">
      <div className="z-container max-w-[860px]">
        <h1 className="font-display text-[40px] md:text-[52px] leading-[1.05]">{t(titleKey)}</h1>
        <p className="mt-3 text-[13px] uppercase tracking-wider text-[color:var(--z-muted)]">{t(updatedKey)}</p>
        <p className="mt-8 text-[16px] leading-relaxed text-[color:var(--z-ink-2)]">{t(introKey)}</p>
        <div className="mt-10 space-y-8">
          {sections.map((s) => (
            <section key={s.titleKey}>
              <h2 className="font-display text-[22px] md:text-[26px] leading-tight">{t(s.titleKey)}</h2>
              <p className="mt-3 text-[15px] leading-relaxed text-[color:var(--z-ink-2)]">{t(s.textKey)}</p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}

export function Privacy() {
  const sections = [1,2,3,4,5,6,7,8,9].map((i) => ({ titleKey: `privacy.s${i}Title`, textKey: `privacy.s${i}` }));
  return <LegalLayout titleKey="privacy.title" updatedKey="privacy.updated" introKey="privacy.intro" sections={sections} />;
}

export function Cookies() {
  const sections = [1,2,3,4,5,6,7].map((i) => ({ titleKey: `cookiePolicy.s${i}Title`, textKey: `cookiePolicy.s${i}` }));
  return <LegalLayout titleKey="cookiePolicy.title" updatedKey="cookiePolicy.updated" introKey="cookiePolicy.intro" sections={sections} />;
}

export function Terms() {
  const sections = [1,2,3,4,5,6,7,8,9].map((i) => ({ titleKey: `terms.s${i}Title`, textKey: `terms.s${i}` }));
  return <LegalLayout titleKey="terms.title" updatedKey="terms.updated" introKey="terms.intro" sections={sections} />;
}
